import { Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import React from 'react';

import {
  CHAIN_ID_TO_KEY_MAP,
  CHAIN_ID_TO_TYPE_MAP,
  WEB3_CONFIG,
} from '../../lib';
import { POOL_IDS } from '../../lib/smart-contract-utils';
import { StakingCard } from './card/StakingCard.component';
import styles from './Farming.module.css';

interface Props {
  isLoggedIn: boolean;
  handleBuyMoreStars?: (lpTokenAddress: string) => void;
  chainId: typeof WEB3_CONFIG.chains[keyof typeof WEB3_CONFIG.chains]['id'];
}

export const FarmingComponent: React.FC<Props> = ({
  isLoggedIn,
  handleBuyMoreStars,
  chainId,
}) => {
  const chainKey = CHAIN_ID_TO_KEY_MAP[chainId];
  const chainType = CHAIN_ID_TO_TYPE_MAP[chainId];

  return (
    <div className={styles.farmingContainer}>
      <div className={styles.headerContainer}>
        <h1 className={styles.farmingHeading}>Farming</h1>
        <button
          className={styles.learnMoreContainer}
          onClick={() =>
            window.open(
              'https://medium.com/mogulproductions/introducing-mogul-growth-farming-ccb4344172e7',
            )
          }
        >
          <div className={styles.learnMore}>
            <h1 className={styles.learnMoreHeader}>
              Mogul Growth Farming
              <ChevronRightIcon className={styles.rightChevron} />
            </h1>
            Learn more about STARS Master Chef and Mogul Growth Farming
            contracts
          </div>
        </button>
      </div>
      <div
        className={`${styles.disabledBg} rounded-xl grid place-items-center py-5`}
      >
        <Typography
          variant="h1"
          style={{ fontSize: 40, textTransform: 'uppercase' }}
        >
          Staking disabled
        </Typography>
        <Typography variant="subtitle1" style={{ fontSize: 24 }}>
          Current farming rewards are paused
        </Typography>
      </div>
      <div className={styles.stakingContainer}>
        <div className={styles.stakingCard}>
          <StakingCard
            asset="STARS"
            lpTokenContract={WEB3_CONFIG.contracts[chainKey].stars}
            isLoggedIn={isLoggedIn}
            poolId={chainType in POOL_IDS ? POOL_IDS[chainType].STARS : 0}
            handleBuyMoreStars={handleBuyMoreStars}
          />
        </div>
        <div className={styles.stakingCard}>
          <StakingCard
            asset="STARS_ETH"
            lpTokenContract={WEB3_CONFIG.contracts[chainKey].starsEth}
            isLoggedIn={isLoggedIn}
            poolId={chainType in POOL_IDS ? POOL_IDS[chainType].STARS_ETH : 0}
            handleBuyMoreStars={handleBuyMoreStars}
          />
        </div>
      </div>
    </div>
  );
};
